import { Helmet } from 'react-helmet';

const ChatMeSDK = () => {
  return (
    <Helmet>
      <script 
        src="https://sdk.chatme.vn/cm.js"
        data-chatme-id="2b3537ee395b403d7875b21465c2043a"
      />
    </Helmet>
  );
};

export default ChatMeSDK; 